import type { Activity, EventItem, NavItem, Value } from '../types/site'

export const LOGO_URL =
  'https://cdn.magicpatterns.com/uploads/djKFrgVWmzoz9XVsCrASod/Logo_MDLN_-_Officiel.png'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/383341f0-4fd0-4b20-83b7-21ae5b7c4ac4.jpg'

export const navigation: NavItem[] = [
  { label: 'Accueil', href: '/' },
  {
    label: 'Évènements',
    href: '/evenements',
    children: [
      { label: 'Agenda', href: '/evenements/agenda' },
      { label: 'Spectacles son et lumière', href: '/evenements/spectacles' },
      { label: 'Archives', href: '/evenements/archives' },
    ],
  },
  { label: 'Chorale', href: '/chorale' },
  { label: 'Poterie', href: '/poterie' },
  { label: 'Ciné-club', href: '/cine-club' },
  {
    label: 'À propos',
    href: '/a-propos',
    children: [
      { label: "L'association", href: '/a-propos/association' },
      { label: 'Notre histoire', href: '/a-propos/histoire' },
      { label: 'Nous contacter', href: '/a-propos/contact' },
    ],
  },
]

export const events: EventItem[] = [
  {
    id: 'cine-oct',
    category: 'Ciné-club',
    title: 'Quand vient l’automne',
    subtitle: 'Séance suivie d’un échange autour du film',
    date: '2026-10-06',
    day: '06',
    month: 'oct.',
    time: '20h30',
    place: 'Salle de la Concorde, Valmont',
    color: '#0F1E2E',
  },
  {
    id: 'choeur-nov',
    category: 'Chœur',
    title: 'Concert d’automne de la chorale',
    subtitle: 'Répertoire français et chants du monde',
    date: '2026-11-14',
    day: '14',
    month: 'nov.',
    time: '18h00',
    place: 'Église de Valmont',
    color: '#1F6D63',
  },
  {
    id: 'poterie-nov',
    category: 'Arts manuels',
    title: 'Portes ouvertes de l’atelier poterie',
    subtitle: 'Tour, modelage et émaillage, ouvert à tous',
    date: '2026-11-21',
    day: '21',
    month: 'nov.',
    time: '14h00',
    place: 'Atelier des Magiciens',
    color: '#E76E31',
  },
  {
    id: 'theatre-dec',
    category: 'Théâtre',
    title: 'Lectures à voix haute',
    subtitle: 'Textes choisis par la troupe, entrée libre',
    date: '2026-12-05',
    day: '05',
    month: 'déc.',
    time: '20h00',
    place: 'Salle de la Concorde, Valmont',
    color: '#7A8B3C',
  },
]

export const activities: Activity[] = [
  {
    slug: 'cine-magic',
    name: 'Ciné-Magic',
    tagline: 'Le ciné-club du village',
    description:
      'Une séance chaque 1er mardi du mois, choisie par les adhérents et suivie d’un temps d’échange.',
    rhythm: '1er mardi du mois — 20h30',
    color: '#0F1E2E',
    href: '/cine-club',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/838f7e67-f65a-45e8-9adf-fa9dece94dfa.jpg',
  },
  {
    slug: 'choeur',
    name: 'Chœur',
    tagline: 'Chanter ensemble',
    description:
      'Une chorale ouverte à toutes les voix, sans audition, avec deux concerts par an.',
    rhythm: 'Répétition le jeudi — 20h00',
    color: '#C14228',
    href: '/chorale',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/c1bc8343-3421-4bdf-aad8-e2813b0ef9b3.jpg',
  },
  {
    slug: 'theatre',
    name: 'Théâtre',
    tagline: 'Jouer, lire, mettre en scène',
    description:
      'Ateliers de jeu et lectures à voix haute, de la première impro jusqu’à la scène.',
    rhythm: 'Atelier le mardi — 18h30',
    color: '#7A8B3C',
    href: '/evenements',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/edc98fd0-78fa-4e0b-acab-992869f712b0.jpg',
  },
  {
    slug: 'poterie',
    name: 'Arts manuels',
    tagline: 'Atelier poterie',
    description:
      'Tour, modelage et émaillage dans un atelier équipé, accompagné par les bénévoles.',
    rhythm: 'Samedi — 14h00 à 17h00',
    color: '#F2B134',
    href: '/poterie',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/b0726dee-3e01-4764-bc84-0b3eb4fff0e9.jpg',
  },
  {
    slug: 'logistique',
    name: 'Logistique & support',
    tagline: 'Faire exister les spectacles',
    description:
      'Décors, son, lumière, accueil du public : l’équipe qui monte les soirées son et lumière.',
    rhythm: 'Selon les projets',
    color: '#1F6D63',
    href: '/a-propos',
  },
]

export const values: Value[] = [
  {
    title: 'Vivre ensemble',
    description: 'Partager, échanger et créer du lien entre les générations.',
    color: '#7A8B3C',
  },
  {
    title: 'Culture pour tous',
    description: 'S’ouvrir, découvrir, s’émerveiller sans barrière de prix ni de niveau.',
    color: '#C14228',
  },
  {
    title: 'Implication',
    description: 'Chacun apporte sa lumière, à la scène comme dans les coulisses.',
    color: '#F2B134',
  },
  {
    title: 'Solidarité',
    description: 'Avancer ensemble, avec bienveillance et le sens du collectif.',
    color: '#1F6D63',
  },
]
